import React from 'react';
import {
  ConnectorRevisionReleaseBannerContainer,
  MessageContainer,
  MessageContent,
  StyledButton,
} from './styles';

const ConnectorRevisionReleaseBanner = () => {
  return (
    <ConnectorRevisionReleaseBannerContainer>
      <MessageContainer>
        <MessageContent>
          There are changes to your connector not included in the latest
          revision.
        </MessageContent>
        <StyledButton>Publish a revision with your changes</StyledButton>
      </MessageContainer>
    </ConnectorRevisionReleaseBannerContainer>
  );
};

export default ConnectorRevisionReleaseBanner;
